import { CSSProperties, JSX } from "react"
import { Location, MilestoneInfo, AnimalGroupInfo, AnimalInfo, FeedCurve, System, SectionsInfo } from "../Services"

export enum ListData_ValueTypes {
  Id = "Id",
  Div = "Div",
  Check = "Check",
  Number = "Number",
  String = "String",
  ProgressBar = "ProgressBar",
  List = "List",
  CreatableList = "CreatableList",
  DeleteRowAction ="DeleteRowAction",
  SelectRowAction = "SelectRowAction",
  Button = "Button",
  Display = "Display",
  Date = "Date",
}

export interface SelectFieldOption_Values extends ModifyWithOptional<ValueType, "id", number|string|null> {
  domain?:string
  style?: CSSProperties
  icon?: JSX.Element
  value?: string
  secondaryLabel?: string
}

/* eslint-disable */
export enum WidgetPlacements {
  dashboard = "dashboard", // widget.placement === 0
  kpi = "kpi", // widget.placement === 1
  report = "report", // widget.placement === 2
  system = "system" // widget.placement === 3
}
/* eslint-enable */

export interface DataValue {
  type?:  ListData_ValueTypes,
  value: string|number|boolean|any //TODO: Sorter virker kun når any eksisterer (Only for the old way)
  style?:CSSProperties,
  static?:boolean,
  select?:SelectFieldOption_Values[],
}
export type DataValue_Keys = keyof DataValue
export type Data = DataValue[]
export type ValueEdit = {row: number, col: number, value: any, key: string}

export enum penTypes {
  basic="basic",
  advanced="advanced",
  simple = "simple",
  penName="penName",
  basicYesterday="basicYesterday",
  basicToday="basicToday"
}

export enum AttentionTypes {
  neutral = "Off",
  good = "Running",
  warning = "Warning",
  alert = "Alert",
}

export enum FeederStatus {
  idle="Idle",
  paused="Paused",
  dosing="Dosing",
  waiting="Waiting",
  measuring="Measuring",
  calibration="Waiting for Calibration",
  error="Error",
  off="Off"
}

export function numberConverter(data:number, format:number = 1000, padding:number = 2):string {
  var result = (Math.round(data)/format).toFixed(padding);
  return result;
}

export type Params = Partial<Pick_Arr<AnimalInfo, "animal_number">>
  & Partial<Pick_Arr<FeedCurve, "feedCurveId">>
  & Partial<Pick_Arr<AnimalGroupInfo, "animal_group_id">>
  & Partial<Pick_Arr<System, "system_id">>
  & Partial<Pick_Arr<MilestoneInfo, "milestone_id">>
  & Partial<Pick_Arr<SectionsInfo, "section_id">>
  & Partial<Pick_Arr<Location, "location_id">>
// key: "" as keyof FilterParameter, value: []

export type DataObj = Extract<keyof Params, string>
// consider doing something with the actual translation files to get this
const LABEL_TRANSLATION_KEYS = ['animalId', 'feedCurve', 'group', 'system', 'milestone', 'section', 'location' ] as const

export type LabelTranslationKey = typeof LABEL_TRANSLATION_KEYS[number];

// Todo still allows for mismatch of label and keys
// eslint-disable-next-line no-unused-vars
const LABEL_KEY_PAIR: {[K in DataObj]: LabelTranslationKey} = {
  "animal_number": "animalId",
  "feedCurveId": "feedCurve",
  "animal_group_id": "group",
  "system_id": "system",
  "milestone_id": "milestone",
  "section_id": "section",
  "location_id": "location"
} as const

// eslint-disable-next-line no-unused-vars
const DATA_LEVELS: {[K in DataObj]: number} = {
  animal_number: 1,
  animal_group_id: 2,
  system_id: 3,
  feedCurveId: 0,
  milestone_id: 0,
  section_id: 0,
  location_id: 0,
} as const


export function getDataLevelFromKey(key?: DataObj): number {
  return key ? DATA_LEVELS[key] : 0
} 

export function getKeyFromDataLevel(dataLevel?: number): DataObj {
  switch (dataLevel) {
    default:
    case 1:
      return "animal_number";
    case 2:
      return "animal_group_id";
    case 3: 
      return "system_id";
  }
}

export function getLabelFromKey(key?: DataObj):  LabelTranslationKey | undefined {
  return key ? LABEL_KEY_PAIR[key] : undefined;
}

export type ValueType = {
  label: string
  id: number
}

export type QuickEntry = {
  key:DataObj,
  value:ValueType[]
}

export type quickEntryChange = {
    key:DataObj, 
    value:any
}


interface ReportBase {
  name?: string
  dataLevel?: number; 
  filterParameter?: QuickEntry[][]
  dataParameter?: DataObj[]
}

export interface ReportData extends WithOptional<WithIdentifier<ReportBase, "reportId">, "reportId"> {
  archived?: boolean,
  startDate?: number,
  endDate?: number,
  deleted?: boolean,
  created?: number,
}

export type ReportTemplate = WithOptional<WithIdentifier<ReportBase, "templateId">, "templateId">;

/* eslint-disable */
export enum MenuFloats {
  left="left",
  right="right",
  center="center"
}
/* eslint-enable */

/* eslint-disable */
export enum PopoverPosition {
  top='top',
  bottom='bottom'
}
/* eslint-enable */

/* eslint-disable */
export enum SectionBasicTypes {
  basicPen = 2,
  advancedPen = 3,
  singlePen = 1,
  selectablePen = 4
}
/* eslint-enable */

export interface BaseSection {
  sectionId: number;
  pens: Location[]
}

/* eslint-disable */
export enum ReportShortCut_Type {
  goTo="Go to",
  delete="Delete"
}
/* eslint-enable */

/* eslint-disable */
// ValueSteps for valueStep/inputfield step
export enum ValueSteps {
  integers = "integers",
  floats = "floats"
}
/* eslint-enable */

/* eslint-disable */
export enum SystemTypes {
  autoPig = "autoPig",
  freedaLf = "freedaLf",
  freedaEsf_WalkThrough = "freedaEsf_WalkThrough",
  freedaEsf_WalkIn = "freedaEsf_WalkIn"
}
/* eslint-enable */